import RelatedPhotosRendererSuspense from '../src/RelatedPhotos/RelatedPhotosRendererSuspense.tsx';
export default RelatedPhotosRendererSuspense;
